<template>
  <Card
    class="koc-default-collection-item-course"
    :updating-overlay-text="item.updatingText"
    :show-updating-overlay="item.isUpdating"
    :course="true"
  >
    <template #image>
      <a :href="FormattingService.formatUrl(item)">
        <div class="koc-default-collection-item-course-image">
          <div
            class="koc-default-collection-item-course-image-thumbnail"
            :style="`background-image: url(${state.imageUrl})`"
          />
          <div
            v-if="trackOrderNumber"
            class="koc-default-collection-item-course-image-track-ribbon"
          />
          <span
            v-if="trackOrderNumber"
            class="koc-default-collection-item-course-image-track-number koc-montserrat"
            :class="trackOrderNumber < 10 ? 'single-digit' : ''"
          >{{ trackOrderNumber }}</span>
          <div
            v-if="state.isCompleted"
            class="koc-default-collection-item-course-image-ribbon"
          />
          <font-awesome-icon
            v-if="state.isCompleted"
            class="koc-default-collection-item-course-image-icon"
            :icon="['fa', 'medal']"
            color="#000000"
            size="lg"
          />
        </div>
      </a>
    </template>
    <template #content>
      <progress-bar
        v-if="user"
        :lessons="item.lessons"
      />
      <div class="koc-details">
        <div class="koc-content">
          <div class="koc-title-2">
            <a
              :href="FormattingService.formatUrl(item)"
              v-html="item.article ? item.article.title : item.title"
            />
          </div>
          <p
            v-if="item.instructors"
            class="koc-instructor koc-body-1"
          >
            <span v-html="FormattingService.memberDashboardLinkedInstructorArray(item.instructors)" />
          </p>
          <p
            v-if="item.course"
            class="koc-course koc-body-2"
            v-html="buildCourseTitle(item.course[0].title)"
          />
          <p
            v-if="item.article"
            class="koc-magazine koc-body-2"
          >
            {{ item.title }}
          </p>
          <p
            v-if="item.type === 'course' || item.type === 'webcast'"
            class="koc-dates koc-body-2"
          >
            <span
              v-if="item.lessons"
              class="koc-body-2 float-right"
            >
              {{ item.lessons.length }} lessons
              <template v-if="item.duration">
                | {{ FormattingService.formatDuration(item.duration) }}
              </template>
            </span>
          </p>
          <p
            v-if="item.type === 'article'"
            class="koc-dates koc-body-2"
          >
            Published: {{ FormattingService.formatDate(item.dates.created, item.type) }}
          </p>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="koc-footer-main">
        <div class="koc-cta">
          <a
            :href="FormattingService.formatUrl(item)"
            class="koc-montserrat koc-title"
          >
            {{ state.footerText }}
          </a>
        </div>
        <div
          v-if="state.status"
          class="koc-footer-main-status"
        >
          <span class="koc-footer-main-status-text">
            {{ state.status === 'completed' ? 'completed' : 'in progress' }}
          </span>
        </div>
        <div
          v-if="item.type === 'course'"
          class="koc-actions"
        >
          <template v-if="item">
            <tooltip
              v-if="user"
              text="Bookmark Course"
              :hide-tooltip="item.isUpdating"
            >
              <button
                :class="{ 'koc-active': state.isBookmarked }"
                class="koc-button koc-ripple koc-clear koc-small koc-text"
                @click="toggleBookmark(item, !state.isBookmarked)"
              >
                <font-awesome-icon
                  :icon="['fa', 'bookmark']"
                />
              </button>
            </tooltip>
            <tooltip
              v-if="user"
              text="Archive Course"
              :hide-tooltip="item.isUpdating"
            >
              <button
                :class="{ 'koc-active': state.isArchived }"
                class="koc-button koc-ripple koc-clear koc-small koc-text"
                @click="toggleArchive(item, !state.isArchived)"
              >
                <font-awesome-icon
                  :icon="['fa', 'box-archive']"
                />
              </button>
            </tooltip>
          </template>
          <tooltip
            text="Course Information"
            :last="true"
            :hide-tooltip="item.isUpdating"
          >
            <button
              v-if="item.type === 'course'"
              class="koc-button koc-ripple koc-clear koc-small koc-text"
              @click="toggleModal(item)"
            >
              <font-awesome-icon
                :icon="['fa', 'info']"
              />
            </button>
          </tooltip>
        </div>
      </div>
    </template>
  </Card>
</template>

<script src="./course.js"></script>
<style lang="scss" scoped src="./course.scss"></style>
